module.exports = __webpack_public_path__ + "static/media/genie0.e2be631c.webm";